import { IAssignment } from '@medely/types';
import { Box, HStack, Icon, Text } from '@medely/ui-kit';
import { HelpCenterLink } from '@mp/components/helpCenterLink';
import { JobDetailsListItem } from '@mp/components/jobs';
import React from 'react';
import { CompensationModal } from './compensationModal/CompensationModal';
import useDialog from '@mp/hooks/useDialog';

const GUARANTEED_MINIMUM_HOURS = 4;

type DetailsBannersProps = {
  assignment: IAssignment;
  smallIcon?: boolean;
};

export const DetailsBanners = ({ assignment, smallIcon }: DetailsBannersProps) => {
  const isW2 = assignment.is_w2;
  const compensationDetailsDialog = useDialog();

  return (
    <Box>
      {!!assignment.estimated_unpaid_break_time_minutes && (
        <Box py={2}>
          <JobDetailsListItem
            icon={
              <Icon
                name="light-burger-soda"
                iconSize={smallIcon ? '14px' : '20px'}
                color="text.primary"
                variant="custom"
              />
            }
            title="Unpaid meal break"
            small
          >
            <Text size="m" color="text.secondary">
              {`Shifts have ${assignment.estimated_unpaid_break_time_minutes} minutes of meal break, which is not included in your total completed hours. `}
              <HelpCenterLink configKey="breaksAndLunches" text="Learn more" />
            </Text>
          </JobDetailsListItem>
        </Box>
      )}
      {assignment.enforce_guaranteed_minimum_hours && (
        <Box py={2} testId="assignment-additional-details-scheduling-assurance">
          <JobDetailsListItem
            icon={
              <Icon
                name="light-shield-check"
                iconSize={smallIcon ? '14px' : '20px'}
                color="text.primary"
                variant="custom"
              />
            }
            title="Scheduling assurance"
            small
          >
            <Text size="m" color="text.secondary">
              {`Book with confidence knowing ${
                assignment.number_of_shifts_per_week * GUARANTEED_MINIMUM_HOURS
              } hours per week are protected by Medely's scheduling assurance guidelines. `}
              <HelpCenterLink configKey="schedulingAssurance" text="Learn more" />
            </Text>
          </JobDetailsListItem>
        </Box>
      )}
      <Box py={2}>
        <JobDetailsListItem
          icon={
            <Icon
              name="light-info-circle"
              iconSize={smallIcon ? '14px' : '20px'}
              color="text.primary"
              variant="custom"
            />
          }
          small
        >
          <HStack gap={0.5} testId="assignment-details-compensation-pay-may-vary-info">
            <Text size="m" color="text.secondary">
              Pay may vary week to week.
            </Text>
            <Box
              onClick={compensationDetailsDialog.openDialog}
              testId="assignment-compensation-info-link"
            >
              <Text size="m" color="state.teal.secondary">
                Learn more
              </Text>
            </Box>
          </HStack>
        </JobDetailsListItem>
      </Box>
      <CompensationModal
        open={compensationDetailsDialog.open}
        onClose={compensationDetailsDialog.closeDialog}
        isW2={isW2}
      />
    </Box>
  );
};
